import { createAction } from 'typesafe-actions'
import { StripeActionTypes } from './types'
import { prefix } from '../../config/config'
import { Plan } from '../../resources/stripe/types'

const actionPrefix = '@@' + prefix + '/'

export const setPlans = createAction(actionPrefix + StripeActionTypes.SET_PLANS)<Array<Plan>>()
